// extracted by mini-css-extract-plugin
module.exports = {"lightbox-wrapper":"light-box-m__lightbox-wrapper__3Wcoe","lightbox":"light-box-m__lightbox__2h4nU","icon-close":"light-box-m__icon-close__3sNp_"};